module.exports = __webpack_public_path__ + "img/client_siga_me.1a8675fb.svg";